@if (isDataLoaded) {
  <div class="container">
    <!-- Demo disclaimer -->
    <div class="row" style="padding-top: 20px;">
      <img [src]="('assets/images/archipelago-logo-small.png' | sanitizeUrl)" style="width: 70px; height: auto;" />
      <div class="col" align="right">
        <app-menu> </app-menu>
      </div>
    </div>
    @if (!isProduction) {
      <div class="row" style="padding-top: 20px;">
        <b style="font-style: italic;">DEMO MODE</b>
        <small>This app does not send any data or report to DFO and is for demonstration purposes only</small>
      </div>
    }
    @if (adminUser) {
      <div class="admin-box">
        <div class="row">
          <h3 class="blue-subheading">
            You are currently logged in as an Archipelago Admin.
          </h3>
        </div>
        <div class="row" align="left">
          <h6 class="descriptive-text">
            All submission functionality and data syncing to server is disabled. Use the admin panel to manage logbooks, user mappings, and replicate and view a user's data.
          </h6>
          @if (userDetails.isValid()) {
            <h5 class="descriptive-text">
              You are currently viewing {{userDetails.userEmail}}'s trip data
            </h5>
          }
        </div>
      </div>
    }
    <!-- Current trip information -->
    <div style="display: flex; flex-direction: column;">
      <div class="sub-block" style="padding-top: 20px; gap: 38px;">
        <h3 i18n style="color: #005D87; font-weight: bold;">
        My Trip
      </h3>
      </div>
      <div class="sub-block" style="padding-top: 25px; gap: 41px;">
        <h5 i18n class="no-bottom-margin" style="color: #005D87; font-weight: bold;">
        Start Date:
      </h5>
        <h5 class="no-bottom-margin" style="color: #005D87">
          {{currTrip.getStartDate() | date}}
        </h5>
      </div>
      <div class="sub-block" style="gap: 50px;">
        <h5 i18n class="no-bottom-margin" style="color: #005D87; font-weight: bold;">
        Logbook:
      </h5>
        <h6 class="no-bottom-margin" style="color: #005D87">
          {{currTrip.logbook}}
        </h6>
      </div>
      <div class="sub-block" style="gap: 73px;">
        <h5 i18n class="no-bottom-margin" style="color: #005D87; font-weight: bold;">
        Vessel:
      </h5>
        <h6 class="no-bottom-margin" style="color: #005D87">
          {{currTrip.vessel}}
        </h6>
      </div>
      <div class="sub-block" style="gap: 20px;">
        <h5 i18n class="no-bottom-margin" style="color: #005D87; font-weight: bold;">
        License Area:
      </h5>
        <h6 class="no-bottom-margin" style="color: #005D87">
          {{currTrip.licenseArea}}
        </h6>
      </div>
      @if (!requestToStartNewTrip) {
        <div class="sub-block-reports" style="padding-top: 35px;">
          <h3 i18n class="trip-reports-header">
        Trip Reports
      </h3>
          <button i18n mat-stroked-button [matMenuTriggerFor]="menu" style="border-color: coral; border-radius: 10px; margin-left: 25px;">
        Create...
      </button>
          <div class="row" style="margin-left: 50px;">
            <div class="col" style="display: flex; justify-content: center;">
              @if (currTrip.endFishingReport.isComplete) {
                <button i18n mat-stroked-button
                style="border-color: coral; border-radius: 10px;" class="create-button" (click)="setNewTripFlag()">Start New Trip</button>
              }
            </div>
          </div>
          <mat-menu #menu="matMenu">
            <button i18n mat-menu-item (click)="toCatchReport()">Catch Report</button>
            <button i18n mat-menu-item (click)="toPauseReport()">Pause Trip</button>
            <button i18n mat-menu-item [disabled]="(!hasCompleteReport(currTrip.dailyCatchReports) && !hasCompleteReport(currTrip.pauseFishingReports)) || currTrip.endFishingReport.isComplete" (click)="toEndReport()"
              matTooltip="Only available if at least one catch or pause report has been completed"
              matTooltipPosition="right">
          End Trip
        </button>
            <button i18n mat-menu-item [disabled]="hasCompleteReport(currTrip.dailyCatchReports) || hasCompleteReport(currTrip.pauseFishingReports)" (click)="toCancelReport()"
              matTooltip="Only available if no catch or pause reports have been completed"
              matTooltipPosition="right">
          Cancel Trip
        </button>
            <button i18n mat-menu-item [disabled]="!currTrip.endFishingReport.isComplete || !hasCompleteReport(currTrip.dailyCatchReports)" (click)="toOffloadReport()"
              matTooltip="Only available if a catch report and end report have been completed"
              matTooltipPosition="right">
          Offload Catch Report
        </button>
            <!-- Hiding national forms
            <button mat-menu-item (click)="toSpeciesAtRiskReport()">Species at Risk</button>
            <button mat-menu-item (click)="toMarineMammalInteractionForm()">Marine Mammal Interaction</button>
            <button mat-menu-item (click)="toLostRecoveredGearForm()">Lost/Recovered Gear</button>
            -->
          </mat-menu>
        </div>
      }
      @if (!requestToStartNewTrip) {
        <section class="table-container mat-elevation-z8" style="margin-top: 25px;" tabindex="0">
          @if (!isMobile) {
            <table mat-table [dataSource]="tableData">
              <!-- Report Type -->
              <ng-container matColumnDef="reportType">
                <th i18n mat-header-cell *matHeaderCellDef> Report Type </th>
                <td i18n mat-cell *matCellDef="let report">
            {report.reportType, select, Start {Start} Catch {Catch} Pause {Pause} End {End} Offload {Offload}}
          </td>
              </ng-container>
              <!-- Report Status -->
              <ng-container matColumnDef="reportStatus">
                <th i18n mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let report">
                  @if (report.reportStatus == 'Incomplete') {
                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                      <span i18n>Incomplete</span>
                      <mat-icon style="color: gray;">remove_circle_outline</mat-icon>
                    </div>
                  }
                  @if (report.reportStatus == 'Not submitted') {
                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                      <span i18n>Not submitted</span>
                      <mat-icon style="color: gray;">remove_circle_outline</mat-icon>
                    </div>
                  }
                  @if (report.reportStatus == 'Awaiting response') {
                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                      <span i18n>Awaiting response</span>
                      <mat-icon style="color: orange;">check_circle_outline</mat-icon>
                    </div>
                  }
                  @if (report.reportStatus == 'Accepted') {
                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                      <span>{{report.reportStatusMsg}}</span>
                      <mat-icon style="color: lawngreen;">check_circle_outline</mat-icon>
                    </div>
                  }
                  @if (report.reportStatus == 'Error with submission') {
                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                      <span i18n>Error with submission</span>
                      <mat-icon style="color: red;">error_outline</mat-icon>
                    </div>
                  }
                </td>
              </ng-container>
              <!-- Report Date and View -->
              <ng-container matColumnDef="reportDate">
                <th mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let report">
                  <div style="display: flex; flex-direction: row; justify-content: space-between;">
                    <span>{{report.reportDate | date}}</span>
                    <mat-icon style="color: gray;">chevron_right</mat-icon>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: tableColumns;" (click)="clickRow(row)"></tr>
            </table>
          }
          <!-- Table Template for Mobile -->
          @if (isMobile) {
            <div>
              @for (report of tableData; track report) {
                <div class="mobile-notification-box">
                  <div class="notification-content" (click)="clickRow(report)">
                    @if (report.reportStatus == 'Incomplete') {
                      <mat-icon class="notification-icon" style="color: gray;">remove_circle_outline</mat-icon>
                    }
                    @if (report.reportStatus == 'Not submitted') {
                      <mat-icon class="notification-icon" style="color: gray;">remove_circle_outline</mat-icon>
                    }
                    @if (report.reportStatus == 'Awaiting response') {
                      <mat-icon class="notification-icon" style="color: orange;">check_circle_outline</mat-icon>
                    }
                    @if (report.reportStatus == 'Accepted') {
                      <mat-icon class="notification-icon" style="color: lawngreen;">check_circle_outline</mat-icon>
                    }
                    @if (report.reportStatus == 'Error with submission') {
                      <mat-icon class="notification-icon" style="color: red;">error_outline</mat-icon>
                    }
                    <div class="report-info">
                      <div class="report-info-line">
                        <span i18n>{report.reportType, select, Start {Start} Catch {Catch} Pause {Pause} End {End} Offload {Offload}}</span>
                        <span class="date">{{ report.reportDate | date }}</span>
                      </div>
                      <div class="report-status-line">
                        <span i18n>{report.reportStatus, select, Incomplete {Incomplete} Not submitted {Not submitted} Awaiting response {Awaiting response} Accepted {Accepted} Error with submission {Error with submission}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </section>
      }
    </div>
    @if (requestToStartNewTrip) {
      <div>
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
        Are you sure you want to start a new trip?
      </h5>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-4">
            <div class="row">
              <button mat-raised-button
                class="fishing-button-blue"
                type="submit"
                (click)="clearNewTripFlag()">
                <span i18n>
              No
            </span>
              </button>
            </div>
          </div>
          <div class="col-2"></div>
          <div class="col-4">
            <div class="row">
              <button mat-raised-button
                class="fishing-button-red"
                type="submit"
                (click)="toNoTripHome()">
                <span i18n>
              Yes
            </span>
              </button>
            </div>
          </div>
          <div class="col-1"></div>
        </div>
      </div>
    }
  </div>
}
